module.exports = __webpack_public_path__ + "static/media/opodlogowe.770f4ca4.svg";